import React from "react";

// Styled components
import styled from "styled-components";
import { About } from "../styles";

// Components
import Toggle from "./Toggle";

// Animation
import { AnimateSharedLayout } from "framer-motion";

// Use scroll animation
import { useScroll } from "./useScroll";
import { fade } from "../animation";

const FaqSection = () => {
  const [element, controls] = useScroll();

  return (
    <Faq variants={fade} ref={element} animate={controls} initial="hidden">
      {/* <h2>My Skils</h2> */}
      <h4>
        <span>My Skills</span>
      </h4>
      <AnimateSharedLayout>
        <Toggle title="FrontEnd">
          <div className="answer">
            <p>
              Worked with technologies like <span><li>React</li></span> and also have intermediate knowledge of <span><li>HTML/CSS</li></span>  and <span><li>Vanilla JavaScript</li></span> 
            </p>
          </div>
        </Toggle>
        <Toggle title="BackEnd">
          <div className="answer">
            <p>
              Familliar with <span><li>NodeJS</li></span> and <span><li>ExpressJS</li></span>
            </p>
          </div>
        </Toggle>
        <Toggle title="Data Structures And Algorithms">
          <div className="answer">
            <p>
              I have solved more than <span>300</span> problems on LeetCode, GeefForGeeks and certain other coding platforms.
            </p>
          </div>
        </Toggle>
        <Toggle title="CS-CORE">
          <div className="answer">
            <p>
              <ul>
                <li><span>Operating Systems</span></li>
                <li><span>Data Base Management Systems</span></li>
                <li><span>Computer Networking</span></li>
              </ul>
            </p>
          </div>
        </Toggle>
      </AnimateSharedLayout>
    </Faq>
  );
};

const Faq = styled(About)`
  display: block;
  span {
    display: block;
  }
  h2 {
    padding-bottom: 2rem;
    font-weight: lighter;
  }
  .faq-line {
    background: #ccc;
    height: 0.2rem;
    margin: 2rem 0rem;
    width: 100%;
  }
  .question {
    padding: 3rem 0rem;
    cursor: pointer;
  }
  .answer {
    padding: 2rem 0rem;
    p {
      padding: 1rem 0rem;
    }
  }
`;

export default FaqSection;
